export default __webpack_public_path__ + "static/media/fj_ajbf.6674b39f.jpg";